import { Col, Row, Space, Typography, Modal, Dropdown, message } from "antd";
import ProgramCategoriesView from "../components/ProgramCategoriesView";
import { useState } from "react";
import ProgramCategoryFormDialog from "../components/ProgramCategoryFormDialog";
import { ProgramCategory } from "../repository/data.default";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import { getProgramCategoriesExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function ProgramCategoriesPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({ conditions: [] });
  const [inputMode, setInputMode] = useState<"add" | "update" | "delete">("add");
  const [inputOpen, setInputOpen] = useState(false);
  const [inputValues, setInputValues] = useState<ProgramCategory>({} as any);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(sq: SearchQuery): void {
    setSearchQuery(sq);
  }

  function onInputOpen(mode: "add" | "update" | "delete", values?: ProgramCategory): void {
    setInputMode(mode);
    setInputOpen(true);
    setInputValues(values || ({} as any));
  }

  function onInputFinish(): void {
    setInputOpen(false);
    setInputValues({} as any);
    setTriggerView(Guid.create().toString());
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading program categories export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getProgramCategoriesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => loading.destroy())
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Program Categories
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("CompanyProgramCategories", "create")}
            className={`${!permissions.can("CompanyProgramCategories", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("CompanyProgramCategories", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onInputOpen("add")}
          >
            Add Program Category
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <ProgramCategoriesView
          trigger={triggerView}
          onAction={(key: string, record: any) => onInputOpen(key as any, record)}
          onSearch={onSearch}
        />
      </Col>
      <ProgramCategoryFormDialog
        key={inputMode}
        mode={inputMode}
        open={inputOpen}
        initialValues={inputValues}
        onFinish={onInputFinish}
        onCancel={() => setInputOpen(false)}
      />
      {contextHolder}
    </Col>
  );
}

export default ProgramCategoriesPage;
